import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
html,
body {
  width: 100%;
  min-height: 100%;
  line-height: normal;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
@-ms-viewport {
  width: device-width;
}
article,
aside,
dialog,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}
@media (max-width: 1199px) {
  html {
    font-size: 14px;
  }
}
@media (min-width: 1200px) {
  html {
    font-size: 16px;
  }
}
body {
  margin: 0;
  color: #999999;
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 1.5;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';  
  &.prevent-overwrite {
    // Ensure styles are applied
    color: #999999 !important;
    font-size: 12px !important;
    font-family: 'Inter', sans-serif !important;
    font-weight: 400 !important;
  }

  w3m-modal {
    background: rgba(13,19,34,0.7);
  }
  wui-flex {
    align-items: center;
  }
  wui-card {
    background: #221B36;
    border-radius: 16px;
  }
}
  
[tabindex='-1']:focus {
  outline: none !important;
}
hr {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}


/* Scrollbar */
/* width */
::-webkit-scrollbar {
  width: 1px;
  height: 1px;
}

/* Track */
::-webkit-scrollbar-track {
  background-color: rgba(48, 38, 77, 0.75);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #999999;
  border-radius: 10px;
}
/* Scrollbar end */

::-moz-scrollbar-thumb {
  background-color: #999999;
}  
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,225, 0.5) rgba(48, 38, 77, 0.75); 
}
 
 
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
}
.h1, h1 {
  font-size: 32px;
  font-weight: 700;
}
.h2, h2 {
  font-size: 24px;
  font-weight: 500;
}
.h3, h3 {
  font-size: 20px;
  font-weight: 500;
}
@media (max-width: 575px) {
  .h1, h1 {
    font-size: 28px;
  }
  .h2, h2 {
    font-size: 20px;
  }
  .h3, h3 {
    font-size: 18px;
  }
}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
label:empty{
  display: none;
}
label.formLabel{
  color: #E6E6E6;
  font-size: 14px;
  text-transform: unset;
}
.text-center{
  text-align: center;
}
.font-md{
  font-weight: 500;
}
.font-10{
  font-size: 10px;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}
address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}
input[type='text'],
input[type='password'],
input[type='number'],
textarea {
  -webkit-appearance: none;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1em;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 500;
}
dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1em;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #421EA1;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:hover,
a:active {
  color: rgba(66, 30, 161, 0.8);
}
a:active,
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}
pre,
code,
kbd,
samp {
  font-size: 1em;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier,
    monospace;
}
pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}
figure {
  margin: 0 0 1em;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
a,
area,
button,
[role='button'],
input:not([type='range']),
label,
select,
summary,
textarea {
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}
th {
  text-align: inherit;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
  &:focus {
    outline: none;
  }
}
button,
select {
  text-transform: none;
}
button,
html [type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
label {
  display: inline-block;
  margin-bottom: 8px;
}
input[type='radio'],
input[type='checkbox'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset:not(.MuiOutlinedInput-notchedOutline) {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
fieldset:not(.MuiOutlinedInput-notchedOutline) legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
mark {
  padding: 0.2em;
  background-color: #feffe6;
}
::selection {
  color: #fff;
  background: #421EA1;
}
`;

export default GlobalStyle;
